import { render, staticRenderFns } from "./TrafikCezasiHesaplayici.vue?vue&type=template&id=50379924"
import script from "./TrafikCezasiHesaplayici.vue?vue&type=script&lang=ts"
export * from "./TrafikCezasiHesaplayici.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports